import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import Truncate from "react-truncate";

export const StyledButton = styled(Button)({
  minWidth: "auto",
  padding: 0,
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const StyledTruncate = styled(Truncate, {
  shouldForwardProp: (prop) => prop !== "isWrapping",
})(({ isWrapping }) => ({
  whiteSpace: isWrapping ? "nowrap" : "normal",
}));
